<template>
  <div
    class="select-game"
  >
    <div class="login-bg">
      <img :src="bgImg" alt="">
    </div>
    <div class="games-box marginB10" v-if="myGames.length">
      <div class="title">我的游戏</div>
      <div class="games">
        <div class="game" @click="handleChangeGame(item)" v-for="item in myGames" :key="item.id">
          <img :src="item.completed_icon_address" alt="">
          <div>{{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="games-box">
      <div class="title">更多游戏</div>
      <div class="games">
        <div class="game" @click="handleChangeGame(item)" v-for="item in otherGames" :key="item.id">
          <img :src="item.completed_icon_address" alt="">
          <div>{{item.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {loginBg} from './mixins';
  import {apiGetGameList} from '@/api/common';
  import dayjs from 'dayjs';

  export default {
    mixins: [loginBg],
    data() {
      return {
        myGames: [],
        otherGames: []
      };
    },
    computed: {
      isTimeShow() {
        // 判断当前日期是否在今天下午18点后并且在后头早上10点前
        //今天下午18点
        const today = dayjs('2023-11-01').set('hour', 18).set('minute', 0).set('second', 0);
        // 后天上午10点
        const next = dayjs('2023-11-03').set('hour', 10).set('minute', 0).set('second', 0);
        const isTimeBetween = dayjs().isAfter(today) && dayjs().isBefore(next);
        return isTimeBetween || false;
      },
      filterStyle () {
        return {
          filter: 'grayscale(100%)',
          '-webkit-filter': 'grayscale(100%)',
          '-moz-filter': 'grayscale(100%)',
          '-ms-filter': 'grayscale(100%)',
          '-o-filter': 'grayscale(100%)'

        };
      }
    },
    mounted() {
      this.getLoginBg();
      this.getGameList();
      let q_from = this.$route.query.from;
      if (q_from) {
        sessionStorage.setItem('from', q_from);
      }
    },
    methods: {
      getGameList() {
        this.showLoading();
        apiGetGameList().then(res => {
          if (res.code === 0) {
            this.myGames  = res.data.My;
            this.otherGames = res.data.More;
          }
        }).finally(() => {
          this.hideLoading();
        });
      },
      handleChangeGame(game) {
        // console.log(game);
        sessionStorage.setItem('gameInfo', JSON.stringify(game));
        sessionStorage.setItem('game_id', game.id);
        this.$router.replace({name: 'UserCenter', query: {game_id: game.id}});
      }
    }
  };
</script>

<style lang="less" scoped>
  .select-game {
    height: 100%;
    overflow: auto;
    background: #EEF2F7;
  }
  .login-bg {
    font-size: 0;
    img {
      width: 100%;
    }
  }
  .games-box {
    width: 100%;
    background: #fff;  
    color: #242424;
    .title {
      font-size: 14px;
      font-weight: 500;
      padding: 12px 17px 4px;
      border-bottom: 1px solid #EEF2F7;
    }
    .games {
      padding: 12px 15px;
      font-size: 12px;
      display: grid;
      grid-gap: 16px 20px;
      // grid-auto-flow: row dense;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      .game {
        width: 68px;
        overflow: hidden;
        img {
          width: 100%;
          height: 68px;
          border-radius: 10px;
        }
      }
    }
  }
</style>